export const getTextByLanguage = (text: string | Record<string, string>, languageField: string): string =>
  typeof text === 'string' ? text : text[languageField];
